import { Button, Col, Row } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import React, { useState } from 'react'
import { motion } from 'framer-motion'

import classes from './Self_Info.module.css'

const SelfInfo = () => {
  const [displayValue, setDisplay] = useState(null)
  const ListTab =["Skills","Experience","Education"]
  // const [isCompact, setCompact] = useState(false)
  const list = {
    visible: { opacity: [0, 1] },
    hidden: { opacity: 0 },
  }
function scrollBelow(el) {
  const elementRect = el.getBoundingClientRect();
  const absoluteElementTop = elementRect.top + window.scrollY;
  const middle = absoluteElementTop - (window.innerHeight / 2 -350) + (el.offsetHeight / 2);

  // Center position = element top + half height - half container height
  const targetScroll = middle;
  console.log(targetScroll);
  window.scrollTo({
    top: targetScroll,
    behavior: "smooth"
  });
}

  return (
    <div>
      <Content className="contentInfoContainer undraggable">
      {displayValue?null:(<>
      <label style={{color:"whitesmoke",opacity:0.7, fontSize:"18px", position:"relative"}}>Click below to know me more! </label></>)
      }
      </Content>
    <Content className="contentInfoContainer">
      
      <motion.div
        initial={{ x: 0, opacity: 0 }}
        transition={{ ease: 'easeIn', duration: 0.8, delay: 0 }}
        animate={{ opacity: [0, 1], x: [100, 0] }}
        id="containerx"
      >
        <Row className="infoTabContainer" id='rowcontainer' style={{borderRadius: '12px', padding: '12px', border: '1px solid rgba(255, 255, 255, 0.38)'}}>
          {ListTab.map((item, index) => ( 
              <Col key={index} style={{ margin: '0 12px' }} className="infoCol">
            <motion.div
              transition={{ ease: 'easeIn', duration: 0.1 }}
              whileTap={{ scale: 0.9, zIndex: 1 }}
            >
              <a
              href='#/'
              key={index}
                className={displayValue === item ? classes.text_skills_active : classes.text_skills}
                onClick={() => {setDisplay(item); scrollBelow(document.getElementById("rowcontainer"))}}
              >
                {item.toUpperCase()}
              </a>
            </motion.div>
          </Col>
          ))}
          
        </Row>
      </motion.div>

      {/* DETAILS OF EACH TAB*/}
      {displayValue === 'Skills' ? (
        <motion.div className="infoContent" animate="visible" variants={list} >
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <h2> SKILLS </h2>
            <Button style={{background:"transparent", color:"white"}} onClick={() => setDisplay(null)}>X</Button>
          </div>
          <motion.div
          
        animate={{ opacity: [0, 0.9], x: [0, 300] }}
        whileHover={{
    scale: 1.1,
    transition: { duration: 0.2 }
  }}
        >
           <img 
    src={require('../img/icon/techstack.png')}
    alt="techstack"
    className='techstack-img'
  />
  </motion.div>
          <Row>
            <Col flex={1}>
              <ul>
                <p>
                  ◉ <u>Language</u> : Javascript, Typescript, Java, C#{' '}
                </p>
                <p>
                  ◉ <u>Library</u> : Reactjs, React, Redux-Saga, Vue, Vue-Router, Vue-Pinia, CSS, Axios{' '}
                </p>
                <p>
                  ◉ <u>Framework</u> : Ant Design(ANTD), Flowbite, TailwindCSS, Bootstraps, Mantine UI, ExpressJS{' '}
                </p>
                <p>
                  ◉ <u>Database</u> : MySql, MongoDB, Google Firebase, OracleDB, Supabase {' '}
                </p>
                <p>
                  ◉ <u>Software</u> : Visual Studio, Eclipse, Postman API, Android Studio, Unity{' '}
                </p>
                <p>
                  ◉ <u>Management Tools</u> : GitLab, Github, JIRA, Trello{' '}
                </p>
                <p>
                  ◉ <u>Testing Tools</u> : Selenium, NightwatchJS, Cypress, JUnit, SonarQube, {' '}
                </p>
              </ul>
            </Col>

          </Row>

          
        </motion.div>

      ) : null}
      {displayValue === 'Education' ? (
        <motion.div 
        className="infoContent" 
        animate="visible" 
        variants={list}
        style={{ position: "relative" }} // parent needs relative
      >
  <div>
    <div style={{display: 'flex', justifyContent: 'space-between'}}>
      <h2> EDUCATION </h2>
      <Button 
        style={{background:"transparent", color:"white", zIndex: 2, position:"relative"}} 
        onClick={() => setDisplay('null')}
      >
        X
      </Button>
    </div>
    <h3 style={{ fontSize: window.innerWidth < 500 ? "1rem" : "2rem" }}> 
      University of Tarumanagara
    </h3>
    <p style={{ fontFamily: 'LeagueSpartan Thin', fontSize: '18px' }}>
      Aug 2015 – Aug 2019 (GPA : 3.29)
    </p>
    <Row>
      <Col flex={1}>
        <ul>
          <p>- IT Lab and Teaching Assistant (2019)</p>
          <p>- Active Member of Tarumanagara English Club (2017-2019)</p>
          <p>- Active Member of Perhimpunan Fotografi Tarumanagara (2018-2019)</p>
        </ul>
      </Col>
    </Row>
  </div>

  {/* Positioned logo */}
  <img 
    src="https://tadkvuntar.wordpress.com/wp-content/uploads/2016/06/logo-untar-1.png" 
    alt="UNTAR-Logo"
    style={{
      maxWidth: "250px",
      opacity: 0.5,
      position: "absolute",
      top: "40px",     // adjust vertical placement
      right: "20px",   // push to the right side
      zIndex: -1        // stays behind text and button
    }}
  />
</motion.div>

      ) : null}
      {displayValue === 'Experience' ? (
        <motion.div className="infoContent" animate="visible" variants={list}> 
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <h2 style={{ fontSize: window.innerWidth < 500 ? "1rem" : "2rem" }}> WORKING EXPERIENCE </h2>
            <Button style={{background:"transparent", color:"white"}} onClick={() => setDisplay('null')}>X</Button>
          </div>
          <Row>
            <Col flex={1}>
            
              <ul>
 <h4 style={{ fontSize: window.innerWidth < 500 ? "0.8rem" : "2rem" }}> 1. Freelance (2023 - current) </h4>
                <ul>
                  <p>
                    Creative Multimedia  (2023 - 2024): <br />
                    - Worked with MASA in Creative Multimedia as Video Editor <br />    
                    - Worked with many local brands under RINKU in Creative Multimedia as Video Editor <br />
                  </p>
                  <p>
                    - Developed BBJ Cargo Website, a logistics and cargo service company(2025)<br /> 
                    - Redesigned SanGallery Project<br /> 
                  </p>
                </ul>

                <br />

                <h4 style={{ fontSize: window.innerWidth < 500 ? "0.8rem" : "2rem" }}> 2. Software Engineer (2019 - 2023) </h4>
                <ul>
                  <p>
                    PT. Trix Studio (Nov 2019  - Dec 2023): <br />
                    - Responsible for websites development with reactjs, nextjs <br />
                    - Responsible for maintaining app developed with react native <br />
                    - Ensuring quality code on internal code and website with QA Tools <br />
                    - Developed mobile apps and features with Cocos Engine, Android Studio <br />
                  </p>
                  <h4>Freelance : </h4>
                  <p>
                    - SanGallery, Classic Movie List powered by themoviedb<br />
                    - Oil & Supplies Service Company Website, <strong> PT.SNP Indonesia</strong> (2022)<br />
                    - Wedding Photographer Website, <strong> MASA </strong>(2022)<br />
                    - Interior Designer Website, <strong> InDesign</strong> (2022)
                  </p>
                </ul>

                <br />
                <h4>3. Game Development and C# Advanced Class Professor's Assistant (2019) </h4>  
                <h4>4. C++ Advanced Class Professor's Assistant(2019) </h4>
                <h4>5. IT Lab Assistant (2019) </h4>  
                <h4>6. PT.Indometic-Intern (2018) </h4>
                <ul>
                  <p>- Developed an e-commerce website </p>
                </ul>
                <br />
              </ul>
            </Col>

          </Row>
        </motion.div>
      ) : null}

      {displayValue === 'Achievement' ? (
        <motion.div className="infoContent" animate="visible" variants={list}>
          <h2 style={{ fontSize: window.innerWidth < 500 ? "1rem" : "2rem" }}> ACHIEVEMENT </h2>
          <Row>
            <Col flex={1}>
              <ul>
                <h4> 1. Skype Broadcast app </h4>
                <ul>
                  <p>Developed an application integrated with skype <br />
                    - With our constrained resources, my team and I have successfully developed an application and website capable of integration with Skype,
                    enabling seamless broadcasting to p wide audience</p>

                </ul>
                <h4>2. App Builder for quick access </h4>
                <ul>
                  <p>- Developed an app to convert website view into mobile view </p>
                </ul>

                <h4>3. Build MASA Website </h4>
                <ul>
                  <p>- Developed an app to convert website view into mobile view </p>
                </ul>

                <br />
              </ul>
            </Col>
  
          </Row>
        </motion.div>
      ) : null}
    </Content>
     </div>
  )
}

export default SelfInfo
